<script>
export default {
  components: {},
  mixins: [],
  emits: ['action'],
  props: {
    label: {
      type: String,
      required: true,
    },
    labelWaiting: {
      type: String,
      required: false,
      default: 'En cours...',
    },
    little: {
      type: Boolean,
      required: false,
      default: true,
    },
    btnClass: {
      type: String,
      required: false,
      default: 'btn-blue',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    isLoading() {
      return this.loading;
    },
  },
  methods: {
    processAction() {
      this.loading = true;
      this.$emit('action');
    },
    init() {
      this.loading = false;
    },
    load() {
      this.loading = true;
    },
  },
};
</script>

<template>
  <button
    :disabled="this.disabled"
    @click="processAction"
    type="submit"
    v-if="!isLoading"
    :class="[this.btnClass, {disabled: this.disabled, xs: this.little}]">
    <slot name="iconLeft" />
    {{ this.label }}
    <slot name="icon" />
  </button>
  <span
    v-else
    class="flex items-center justify-center gap-2 pointer-events-none"
    :class="[this.btnClass, {disabled: this.disabled, xs: this.little}]"
    >{{ this.labelWaiting }}<span class="spinner white"></span
  ></span>
</template>
